import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TableCursosUsuarios from "../../DataTables/CursosUsuario/TableCursosUsuarios";

const DashboardCursosUsuario = ({ isTabActive }) => {
  return (
    isTabActive && (
      <Container fluid className="pt-4">
        <Row>
          <Col align="left">
            {/* <Button variant="primary" onClick={handleAgregarAdministrador}>
							Agregar administrador
						</Button> */}
          </Col>
        </Row>

        <Row className="mt-3">
          <Col>
            <TableCursosUsuarios />
          </Col>
        </Row>
      </Container>
    )
  );
};

export default DashboardCursosUsuario;
